import { atom } from "@reatom/framework";

export const addAccessRightModalOpen = atom(false, "addAccessRightModalOpen");
